import { ref } from 'vue';

import * as Token from "@/modules/token";
import * as Service from '@/modules/service';
import * as Debug from "@/modules/debug";


export const details = ref(
{
	id: 0,
	name: { first: 'Guest', last: '' },
	email: '',
	identityCard: { type: 0, value: '' },
	lang: 'es',
	phone: { humanized: '', value: '' },
	phoneExtra: '',
	billingPreference: 0,
	billingAddress:
	{
		nif: { type: 0, value: '' },
		company: '',
		address: '',
		zip: '',
		city: '',
		state: '',
		country: 'ES'
	}
} );



export async function Login ( email, password )
{
	// The token fetch will automatically validate the token and populate the user ID. A token fetch should only be done in the first login, and not
	// in the token refresh. A new token fetch will actually log out any user by default if the authentication fails.
	await Token.Fetch( email, password );
	
	// Logged in = user ID > 0
	if ( Token.Get_user_id() > 0 )
	{
		// Fetch the user details from the API
		let details = await Fetch_details();
		
		// If there are valid details, the login is complete. If not, we must make sure that there is a logout.
		if ( details && Update_details( details ) )
		{
			Debug.Security.User.Add( 'login', email + ' : <password>', JSON.stringify( details ) );
			return true;
		}
		
		// The scenario up to here: the token fetch is successful but the user details fetch is not. We must manually destroy the token.
		Token.Clear();
	}
	
	Debug.Security.User.Add( 'login', email + ' : <password>', false );
	
	// Destroy the current user session
	Clear();
	
	return false;
}


// Intenta recuperar el token de la base de datos del navegador y actualizarlo
export async function Recover ()
{
	Debug.Security.User.Add( 'recover', 'try', '?' );
	
	await Token.Check_refresh();
	
	// Pasos a seguir:
	// 1- recuperar el token
	// 2- si hay token, no importa si está o no caducado, intentar refrescarlo (ya se encargará la parte de PHP de decirnos más cosas)
	// 3- si no hay token, devolver false
	if ( Token.Get() )
	{
		// Fetch the user details from the API
		let details = await Fetch_details();
		
		// If there are valid details, the login is complete. If not, we must make sure that there is a logout.
		if ( details && Update_details( details ) )
		{
			Debug.Security.User.Add( 'recover', null, JSON.stringify( details ) );
			return true;
		}
		
		// The scenario up to here: the token exists but cannot be used to fetch the user details (expired or invalid).
		Token.Clear();
	}
	
	// Nos aseguramos de eliminar cualquier información de usuario si no se puede recuperar el token
	Debug.Security.User.Add( 'recover', 'try', false );
	
	Clear();
	
	return false;
}


export async function Fetch ()
{
	if ( Token.Get() )
	{
		let details = await Fetch_details();
		
		if ( details && Update_details( details ) )
		{
			Debug.Security.User.Add( 'fetch', null, JSON.stringify( details ) );
			return true;
		}
	}
	
	Debug.Security.User.Add( 'fetch', null, false );
	
	return false;
}


export function Clear ()
{
	details.value =
	{
		id: 0,
		name: { first: 'Guest', last: '' },
		email: '',
		identityCard: { type: 0, value: '' },
		lang: 'es',
		phone: { humanized: '', value: '' },
		phoneExtra: '',
		billingPreference: 0,
		billingAddress:
		{
			nif: { type: 0, value: '' },
			company: '',
			address: '',
			zip: '',
			city: '',
			state: '',
			country: 'ES'
		}
	};
}


export function Logout ()
{
	Clear();
	Token.Clear();
}


export function Is_logged_in ()
{
	return Token.Get_user_id() > 0;
}


/*********************************************************************/


async function Fetch_details ()
{
	let user_id = Token.Get_user_id();
	
	if ( !( user_id > 0 ) )
		return false;
	
	let result = await Service.Send( {
		endpoint: 'client/get',
		data:
		{
			'id': user_id
		}
	} );
	
	Service.Show_result_messages( result );
	
	Debug.Console( 'Fetch user details', result );
	Debug.Security.User.Add( 'get details', user_id, JSON.stringify( result ) );
	
	if ( result?.ok && result?.data && ( result?.data?.id == user_id ) && result?.data?.active )
		return result.data;
	
	return false;
}


function Update_details ( user_data )
{
	const required_fields = [ 'id', 'gender', 'name', 'email', 'lang' ];
	
	let valid = true;
	
	required_fields.forEach( field => valid = valid && ( field in user_data ) );
	
	if ( !valid )
		return false;
	
	details.value.id = user_data.id;
	details.value.email = user_data.email;
	details.value.lang = user_data.lang;
	
	details.value.name.first = user_data.name?.first;
	details.value.name.last = user_data.name?.last;
	
	details.value.identityCard.type = user_data?.identityCard?.type;
	details.value.identityCard.value = user_data?.identityCard?.value;
	
	details.value.phone.value = user_data?.phone?.value;
	details.value.phone.humanized = user_data?.phone?.humanized;
	
	details.value.phoneExtra = user_data?.phoneExtra;
	
	details.value.billingPreference = user_data?.billingPreference;
	details.value.billingAddress.company = user_data?.billingAddress?.company;
	details.value.billingAddress.nif.type = user_data?.billingAddress?.nif?.type;
	details.value.billingAddress.nif.value = user_data?.billingAddress?.nif?.value;
	details.value.billingAddress.address = user_data?.billingAddress?.address;
	details.value.billingAddress.zip = user_data?.billingAddress?.zip;
	details.value.billingAddress.city = user_data?.billingAddress?.city;
	details.value.billingAddress.state = user_data?.billingAddress?.state;
	details.value.billingAddress.country = user_data?.billingAddress?.country;
	
	return true;
}



































export async function xRefresh ()
{
	let details = await Fetch_details();
	
	if ( details && Update_details( details ) )
	{
		Debug.Security.User.Add( 'refresh', null, JSON.stringify( details ) );
		return true;
	}
	
	return false;
}


/***************************************************************/






import { useRouter } from 'vue-router';
import * as Notifications from '@/modules/notifications';

let keepalive_handler = null;


export function xSet_keepalive ()
{
	keepalive_handler = setInterval( async () =>
	{
		const router = useRouter();

		if ( !( await Refresh() ) )
			await router.push( { name: 'Login' } );
	}, Token.Get_expiration_period() * 1000 );
}


export function xClear_keepalive ()
{
	clearInterval( keepalive_handler );
}


// Borra el token guardado y toda la información del usuario
export function xLogout ()
{
	is_logged_in.value = false;
	
	Token.Clear();
	Clear_details();
	Clear_roles();
	Clear_keepalive();
	
	Debug.Security.User.Add( 'logout', '', '' );
}


function xUpdate_login ( login_package )
{
	if ( login_package?.data?.is_logged_in
		&&
		login_package?.data?.token
		&&
		login_package?.data?.user_details
		&&
		login_package?.data?.user_roles
		&&
		Token.Is_valid( login_package.data.token )
		&&
		Save_details( login_package.data.user_details ) )
	{
		Save_roles( login_package.data.user_roles );
		
		Clear_keepalive();
		Set_keepalive();
		
		is_logged_in.value = true;
		
		Notifications.Clear();
		
		return true;
	}
	
	return false;
}


function xSave_details ( new_details )
{
	if ( !new_details?.id || !new_details?.name || !new_details?.email )
		return false;
	
	details.value.id = new_details.id;
	details.value.name = new_details.name;
	details.value.last_name = 'last_name' in new_details ? new_details.last_name : '';
	details.value.email = new_details.email;
	
	localStorage.setItem( 'user_details', JSON.stringify( details.value ) );
	
	return true;
}


function xClear_details ()
{
	details.value.id = null;
	details.value.name = 'Guest';
	details.value.last_name = '';
	details.value.email = '';
	
	localStorage.removeItem( 'user_details' );
}


// Needs all the roles
export function xCan ( test_roles )
{
	let result = true;
	
	// the roles come in a flat array combined structure format, delimiting each level by ':', e.g. 'rooms:cleaning:edit'
	test_roles.forEach( role => result = result && roles.includes( role ) );
	
	// Debug.Security.User.Add( 'can', test_roles.join( ', ' ), result );
	
	return result;
}


// Needs some roles
export function xMay ( test_roles )
{
	let result = false;
	
	// the roles come in a flat array combined structure format, delimiting each level by ':', e.g. 'rooms:cleaning:edit'
	test_roles.forEach( role => result = result || roles.includes( role ) );
	
	// Debug.Security.User.Add( 'may', test_roles.join( ', ' ), result );
	
	return result;
}


export function xIs_user ()
{
	return precalculated_roles.value.user;
}


export function xIs_admin ()
{
	return precalculated_roles.value.admin;
}
